import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LoadCreateWorkspaceComponent } from './load-create-workspace.component';
import { LoadFileviewerComponent } from './load-fileviewer.component';
import { LoadMapviewerComponent } from './load-mapviewer.component';
import { LoadSurveyViewerComponent } from './load-surveyviewer.component';

@NgModule({
    declarations: [
        LoadFileviewerComponent,
        LoadMapviewerComponent,
        LoadCreateWorkspaceComponent,
        LoadSurveyViewerComponent
    ],
    imports: [RouterModule, CommonModule],
    exports: [LoadFileviewerComponent, LoadMapviewerComponent, LoadCreateWorkspaceComponent, LoadSurveyViewerComponent]
})
export class InitModule {}
